import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from './cropImage.js';

const cropContainerStyle = {
    position: 'absolute',
    marginTop: '10%',
    backgroundColor: 'white',
    top: '0',
    left: '0',
    right: '0',
    bottom: '80px'
}
const controlsStyle = {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    width: '50%',
    transform: 'translateX(-50%)',
    height: '40px',
    display: 'flex',
    alignItems: 'center'
}
const sliderStyle = {
    padding: '22px 0px',
    marginRight: '2%'
}
const buttonAreaStyle = {
    display: 'flex',
    justifyContent: 'space-between',
}

const buttonStyle = {
    marginRight: '3%'
}

const ImageCropper = ({ imageSrc, onImageCropped, aspectRatio, format, pictureSize, onCancel, link }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const onZoomChange = (zoom) => {
        setZoom(zoom);
    };

    const onCropChange = (crop) => {
        setCrop(crop);
    };

    const cropImage = async () => {
        try {
            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels, format, pictureSize);
            onImageCropped(croppedImage, link);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <>
            <div>
                <div style={cropContainerStyle}>
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspectRatio}
                        onCropChange={onCropChange}
                        onZoomChange={onZoomChange}
                        onCropComplete={onCropComplete}
                    />
                </div>
                <div style={controlsStyle}>
                        <input
                            type="range"
                            min={1}
                            max={3}
                            step={0.1}
                            value={zoom}
                            onInput={(e) => {
                                onZoomChange(e.target.value);
                            }}
                            style={sliderStyle}
                        ></input>
                    <div style={buttonAreaStyle}>
                            <button style={buttonStyle} className='button button-color-primary  button-shrink-limited'
                                onClick={cropImage}>
                                Crop
                            </button>
                        
                        <button className='action-element output-action-element--button action-element-style--button button-toggler button-color-secondary button-shrink-limited inherited-icon-color' 
                            onClick={onCancel}>
                                Cancel
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImageCropper;
